import { Table } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FairTopListFormValues } from '../pages/FairTopListPage';
import FairTopListItem from './FairTopListItem';

function FairTopListForm() {
  const { t } = useTranslation();

  // form setup
  const { control, register, setValue } = useFormContext<FairTopListFormValues>();
  const { fields, move } = useFieldArray({
    control,
    name: 'fairtops',
  });

  return (
    <>
      {/* list data */}
      <div className="sticky-table flex-grow-1 flex-shrink-1">
        <Table hover>
          <thead>
            <tr>
              <th style={{ width: '4%' }}>{t('FairTopListPage.display_order')}</th>
              <th style={{ width: '10%' }}>{t('FairTopListPage.move_action')}</th>
              <th style={{ width: '20%' }}>{t('FairTopListPage.subgenre_name')}</th>
              <th style={{ width: '26%' }}>{t('FairTopListPage.dest1')}</th>
              <th style={{ width: '26%' }}>{t('FairTopListPage.dest2')}</th>
              <th style={{ width: '14%' }}>{t('FairTopListPage.date_range')}</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((field, index) => {
              return (
                <FairTopListItem
                  key={field.id}
                  index={index}
                  field={field}
                  control={control}
                  setValue={setValue}
                  register={register}
                  move={move}
                  fieldsLength={fields.length}
                />
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default FairTopListForm;
